import { Falcon } from '@pocketlaw/tetris/macro';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { ItemLink } from '../ItemLink';
export function BackOffice() {
    const show = useFeatureFlag('feature_customer_success');
    if (!show) {
        return null;
    }
    return (<ItemLink to="/back-office" icon={<Falcon icon="briefcase"/>} label="Back office" matchPath={['/back-office']}/>);
}
